import React, { useEffect, useState } from 'react';

const DiagPage: React.FC = () => {
  const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const [health, setHealth] = useState<any>(null);
  const [programsMeta, setProgramsMeta] = useState<{ total?: number; sampleName?: string } | null>(null);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const run = async () => {
      try {
        if (apiBase) {
          const h = await fetch(`${apiBase}/health`).then(r => r.json());
          setHealth(h);
          const p = await fetch(`${apiBase}/programs?page=1&per_page=1`).then(r => r.json()).catch(() => null);
          if (p && p.pagination) {
            setProgramsMeta({ total: p.pagination.total, sampleName: p.items?.[0]?.name });
          }
        }
      } catch (e: any) {
        setError(String(e));
      }
    };
    run();
  }, [apiBase]);

  return (
    <div style={{ padding: 16 }}>
      <h2>Diagnostics</h2>
      <div><strong>Build:</strong> {process.env.REACT_APP_BUILD_TAG || 'n/a'} </div>
      <div><strong>API base:</strong> {apiBase || '(not set)'} </div>
      <hr />
      <h3>API Health</h3>
      <pre>{health ? JSON.stringify(health, null, 2) : 'Loading or not configured'}</pre>
      <h3>Programs</h3>
      <pre>{programsMeta ? JSON.stringify(programsMeta, null, 2) : 'Loading or not configured'}</pre>
      {error && (
        <>
          <h3>Error</h3>
          <pre>{error}</pre>
        </>
      )}
    </div>
  );
};

export default DiagPage;
